(ns manage.content-configuration-page.view.datoms
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            [clojure.string :refer [join]]
            [common.datascript.init :refer [conn]]
            [common.datascript.schema :as ds]
            [datascript.core :as d]
            [re-frame.core :as rf]
            [uix.core :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui schema-icon [{:keys [d key value icon-name]}]
  (let [schema (d/schema @conn)
        property-value (get-in schema [(:a d) key])]
    (when (if (some? value)
            (= property-value value)
            property-value)
      ($ Icon {:font-size "small"} icon-name))))

(rf/reg-sub ::tx-storage-failure?
  :<- [:manage.content-configuration-page.view.save/unsaved-transactions]
  (fn [unsaved-transactions [_ tx-id]]
    (boolean (some #(= (key %) tx-id) unsaved-transactions))))

(defui datom [{:keys [d]}]
  (let [value (pr-str (:v d))
        is-storage-failure (use-subscribe [::tx-storage-failure? (:tx d)])
        schema (d/schema @conn)]
    ($ Typography (cond-> {:component "tr"
                           :variant "caption"}
                    is-storage-failure (assoc :color "error"
                                              :font-weight "600"))
       ;; primary key/indexed?
       ($ :td ($ schema-icon {:d d
                              :key :db/unique
                              :icon-name "vpn_key"}))
       ;; cardinality many?
       ($ :td ($ schema-icon {:d d
                              :keys :db/cardinality
                              :value :db.cardinality/many
                              :icon-name "account_tree"}))
       ;; owning relation?
       ($ :td ($ schema-icon {:d d
                              :key :db/isComponent
                              :icon-name "view_sidebar"}))
       ;; attribute (keyword) within entity
       ($ :td (pr-str (:a d)))
       ($ :td
          ;; if it is a reference, make link to entity, otherwise show value
          (if (ds/ref? schema (:a d))
            ($ Link
               {:on-click (fn []
                            (.. js/document
                                (getElementById value)
                                (scrollIntoView #js {:behavior "smooth"})))
                :underline "none"
                :sx #js {:fontWeight "600"
                         :cursor "pointer"}}
               value)
            ($ Typography {:component "span"
                           :font-family "monospace"
                           :font-size "inherit"}
               value)))
       ;; type of value
       ($ :td (pr-str (type (:v d))))
       ;; transaction id
       ($ :td (:tx d)))))

(defn- entity-type [datoms]
  (->> datoms
       (map (comp namespace :a))
       frequencies
       (sort-by second >)
       (map first)
       (join ", ")))

(defui entity [{:keys [e datoms]}]
  ($ :<>
     ($ :tr
        ($ Box {:component "td"
                :background-color "grey.70"
                :p 1
                :border-radius "0.25rem"
                :font-weight "600"
                :colSpan 7}
           ($ :a {:id e}
              (str e " - " (entity-type datoms)))))
     (for [d (sort-by :tx datoms)]
       ($ datom {:key (pr-str d)
                 :d d}))))

(defui datoms-table []
  (let [[_i set-i] (react/useState 0)]
    ($ :div
       ($ :button
          {:type "button"
           :on-click (fn [_e] (set-i inc))}
          "Refresh")
       ($ :table {:style {:width "100%"}}
          ($ :tbody
             (for [[e datoms] (sort-by first (group-by :e (drop 6 (d/datoms @conn :eavt))))]
               ($ entity {:key e
                          :e e
                          :datoms datoms})))))))
